// SCAH 10-photo advocacy gallery preset for the admin Bulk Import feature.
// Kept in its own module so the visual-edits babel plugin doesn't try to
// statically analyze the large literal inside AdminDashboard.jsx (which
// triggers a "Maximum call stack size exceeded" build error).

const SCAH_ADVOCACY_PRESET = [
  {
    url: "https://customer-assets.emergentagent.com/job_09d31ad3-68a4-4a96-911c-b360926d284c/artifacts/4fw6gxut_HB3673.jfif",
    caption: "HB 3673 Heard in Committee - SCAH advocates with Rep. Jarvis Johnson at the Texas State Capitol",
    category: "advocacy",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_09d31ad3-68a4-4a96-911c-b360926d284c/artifacts/6nmsfobm_TPrince%20National%20Advocate.jfif",
    caption: 'Tonya Prince - 2019 National Advocate: "The sickle cell community motivates me. They give me life, happiness, and purpose."',
    category: "advocacy",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_09d31ad3-68a4-4a96-911c-b360926d284c/artifacts/wubcmohz_HB107.jpg",
    caption: "HB 107 Sickle Cell Registry Bill PASSED - a coalition victory for the sickle cell community",
    category: "advocacy",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_09d31ad3-68a4-4a96-911c-b360926d284c/artifacts/hogrn7sn_HCR68.jpg",
    caption: "HCR 86 Adopted - Legislative recognition delivered by State Representative Jarvis Johnson",
    category: "advocacy",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_09d31ad3-68a4-4a96-911c-b360926d284c/artifacts/6zj58ipu_raredisease%20rare%20voice%20award.jpg",
    caption: "Tonya Prince honored at the RareVoice Awards - a celebration of rare disease advocates",
    category: "advocacy",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_09d31ad3-68a4-4a96-911c-b360926d284c/artifacts/qo81p947_Mayor%20Turner.jpg",
    caption: "Honorable Mayor Sylvester Turner recognizing sickle cell warriors as a vulnerable population",
    category: "advocacy",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_09d31ad3-68a4-4a96-911c-b360926d284c/artifacts/co8r8h5j_State%20Capital.jpg",
    caption: "Tonya Prince delivering testimony at the Texas State Capitol",
    category: "advocacy",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_09d31ad3-68a4-4a96-911c-b360926d284c/artifacts/qdcqjs08_State%20Capital%202.jpg",
    caption: "SCAH leadership and advocates at the Texas State Capitol",
    category: "advocacy",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_09d31ad3-68a4-4a96-911c-b360926d284c/artifacts/7zaoli5v_TonyaPrince%20public%20health%20committe%20testimony.jpg",
    caption: "Tonya Prince testifying before the Texas House Committee on Public Health",
    category: "advocacy",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_09d31ad3-68a4-4a96-911c-b360926d284c/artifacts/jbellath_Golie.TedCruz.jpg",
    caption: "SCAH advocate meets with U.S. Senator Ted Cruz to discuss sickle cell policy",
    category: "advocacy",
  },
];

export default SCAH_ADVOCACY_PRESET;
